import { styled, Box } from '@material-ui/core';

export const Container = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px 10px 4px',
  minHeight: '236px',
  maxHeight: '236px',
});
